const STORAGE_KEY = "paginationSettings";

const DEFAULT_PAGINATION_SETTINGS = {
  musteriler: 10,
  kullanicilar: 10,
  isler: 20,
  musterinotlar: 10,
  yapilacaklar: 10,
  fikirler: 10,
  roller: 10,
  isturler: 10,
  bildirimler: 10,
  raporlar: 10,
  musteriDetayDevamEdenIsler: 10,
  musteriDetayTamamlananIsler: 10,
  kullaniciDetayElindekiIsler: 10,
  kullaniciDetayTamamlananIsler: 10,
  elimdekiIsler: 20,
};

function readSettings() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) {
      return { ...DEFAULT_PAGINATION_SETTINGS };
    }

    const parsed = JSON.parse(raw);
    return {
      ...DEFAULT_PAGINATION_SETTINGS,
      ...(parsed || {}),
    };
  } catch (error) {
    return { ...DEFAULT_PAGINATION_SETTINGS };
  }
}

function writeSettings(settings) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(settings));
}

export function getAllPaginationSettings() {
  return readSettings();
}

export function getModulePageSize(moduleKey) {
  const settings = readSettings();
  const value = Number(settings[moduleKey]);
  if (Number.isFinite(value) && value > 0) {
    return value;
  }
  return DEFAULT_PAGINATION_SETTINGS[moduleKey] || 10;
}

export function setModulePageSize(moduleKey, value) {
  const numericValue = Number(value);
  if (!Number.isFinite(numericValue) || numericValue <= 0) {
    return;
  }

  const settings = readSettings();
  settings[moduleKey] = Math.round(numericValue);
  writeSettings(settings);
}

export function resetPaginationSettings() {
  writeSettings({ ...DEFAULT_PAGINATION_SETTINGS });
}

export { DEFAULT_PAGINATION_SETTINGS };
